// @flow
import styled from 'styled-components';

export const Container: any = styled.div`
  display: flex;
`;

export default Container;
